<!-- <div class="table-wrapper" style="overflow-x: auto"> -->
<ngx-datatable
  #table
  [style.width.px]="'50vw'"
  class="material"
  [rows]="flattenedRows"
  [columns]="visibleColumns"
  [columnMode]="'standard'"
  [headerHeight]="40"
  [footerHeight]="0"
  [rowHeight]="40"
  (activate)="onCellActivate($event)"
  [externalSorting]="true"
  (sort)="onSort($event)"
  [scrollbarH]="true"
  [scrollbarV]="true"
>
  <!-- <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template>
        <div class="footer-total-row">
          <div
            *ngFor="let col of visibleColumns"
            class="footer-cell"
            [style.width.px]="col.width"
          >
            <strong>
              {{
              col.prop === 'name' && col.levelIndex===0
              ? 'Total'
              : (col.prop && col.prop !== 'name' && grandTotalRow?.[col.prop] !== undefined && grandTotalRow?.[col.prop] !== null
              ? (col.type=='number' ? (grandTotalRow[col.prop] | number : "1.0-0") : (grandTotalRow[col.prop] | number : "1.1-1") +'%')
              : '')
              }}
            </strong>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-footer> -->

<div class="table-spinner-overlay" *ngIf="isLoading">
  <mat-spinner diameter="40"></mat-spinner>
</div>
<ng-template #percentageCell let-value="value">
  {{ value | number : "1.1-1" }}%
</ng-template>
<ng-template #numberCell let-value="value">
  {{ value | number : "1.0-0" }}
</ng-template>
<ng-template
  #treeCell
  let-row="row"
  let-rowIndex="rowIndex"
  let-columnIndex="columnIndex"
  let-value="value"
  let-column="column"
>
  <div
    *ngIf="row.isTotal && row.level === column.levelIndex + 1"
    style="font-weight: bold; color: #444"
  >
    {{ row.name }}
  </div>

  <div
    *ngIf="!row.isTotal && row.level === column.levelIndex + 1"
    style="display: flex; align-items: center; justify-content: space-between"
    [ngClass]="{
      'highlight-cell': highlightedCells.includes(rowIndex + '-' + column.prop)
    }"
  >
    <div style="display: flex; align-items: center; gap: 4px; cursor: pointer">
      <mat-icon
        (click)="toggleExpand(row); $event.stopPropagation()"
        *ngIf="row.children?.length"
        style="
          font-size: calc(18px * var(--dvm-font-scale, 1));
          line-height: 1;
          display: flex;
          align-items: center;
        "
      >
        {{ row.expanded ? "remove_circle_outline" : "add_circle_outline" }}
      </mat-icon>

      <div
        style="
          font-weight: bold;
          color: #444;
          display: flex;
          align-items: center;
        "
      >
        {{ row.name }}
      </div>
    </div>

    <mat-icon
      (click)="$event.stopPropagation()"
      *ngIf="hasNavigation(column.levelIndex)"
      [matMenuTriggerFor]="menu"
      >more_vert</mat-icon
    >
  </div>
  <mat-menu #menu="matMenu">
    <ng-container *ngFor="let navItem of data.navigation">
      <button
        mat-menu-item
        *ngIf="column.levelIndex === navItem.level"
        (click)="onNavigate(navItem, row)"
      >
        {{ navItem.name }}
      </button>
    </ng-container>
  </mat-menu>
</ng-template>

<ng-template #infoIconHeader let-column="column">
  <div
    style="display: flex; align-items: center; flex-grow: 1"
    [ngClass]="'justify-' + column.alignment"
  >
    <span [title]="column.name">{{ column.name }}</span>
    <mat-icon
      *ngIf="column.infoIcon"
      [matTooltip]="column.infoText"
      class="info-icon"
      >info_outline</mat-icon
    >
  </div>
</ng-template>
</ngx-datatable>


<!-- Sticky total row -->

<!-- Sticky total row -->
<div class="sticky-total-row" #totalRow>
  <div
    *ngFor="let col of visibleColumns; let i = index"
    class="total-cell"
    [class.total-cell-fixed]="col.prop === 'name' && col.levelIndex === 0"
    [style.width.px]="col.width"
  >
    <strong>
              {{
              col.prop === 'name' && col.levelIndex===0
              ? 'Total'
              : (col.prop && col.prop !== 'name' && grandTotalRow?.[col.prop] !== undefined && grandTotalRow?.[col.prop] !== null
              ? (col.type=='number' ? (grandTotalRow[col.prop] | number : "1.0-0") : (grandTotalRow[col.prop] | number : "1.1-1") +'%')
              : '')
              }}
            </strong>
  </div>
</div>

<!-- </div> -->
